import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import { Subject, takeUntil } from 'rxjs';
import { Account } from 'app/_helper/user/user.types';
import { UserService } from 'app/_services/user.service';
import { MatDividerModule } from '@angular/material/divider';
import { CommonFileModules } from 'app/_commoncomponent/_commonmodule.module';
import { productFruits } from 'product-fruits';

declare global {
  interface Window { productFruits: any; }
}
@Component({
  selector: 'user',
  templateUrl: './user.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'user',
  standalone: true,
  imports: [MatDividerModule, CommonFileModules],
})
export class UserComponent {
  /* eslint-disable @typescript-eslint/naming-convention */
  static ngAcceptInputType_showAvatar: BooleanInput;
  /* eslint-enable @typescript-eslint/naming-convention */
  @Input() showAvatar: boolean = true;
  user: Account;

  private _unsubscribeAll: Subject<any> = new Subject<any>();


  /**
   * Constructor
   */
  constructor(private _changeDetectorRef: ChangeDetectorRef, private _router: Router, private _userService: UserService) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  async ngOnInit() {
    // Subscribe to user changes
    // this.user = userData;
    const logUser = JSON.parse(localStorage.getItem('userData'));
    this.user = logUser;
    this._userService.user$ = this.user;
    // .pipe(takeUntil(this._unsubscribeAll)).subscribe((user: User) => {
    // this.user = user;
 
    // Mark for check
    this._changeDetectorRef.markForCheck();
    // });
    
    let hostname = window.location.hostname.replace(/\./g, '');    
    
    if (hostname.includes('fieldpal')){
      this.loadPf();   
    }    
    
  }


  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Update the user status
   *
   * @param status
   */
  // updateUserStatus(status: string): void {
  //   // Return if user is not available
  //   if (!this.user) {
  //     return;
  //   }

  //   // Update the user
  //   this._userService
  //     .update({
  //       ...this.user,
  //     })
  //     .subscribe();
  // }

  /**
   * Sign out
   */
  signOut(): void {
    this._router.navigate(['/sign-out']);
  }

  changePassword(): void {
    this._router.navigate(['/change-password']);
  }
backToApps(): void {
    window.location.href = "../auth/dashboard";
  }
  loadPf(){productFruits.init('jfPdZKKm0OF3SIUx' , 'en', { username: this.user.email }, { disableLocationChangeDetection: false });
}
}
type PfWindow = {productFruits: any;}
